import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './navbar.css';
import { getCurrentUser, logout } from '../utils/auth';
import { Avatar, Dropdown } from 'antd';
import { UserOutlined } from '@ant-design/icons';

export default function Navbar() {
  const [user, setUser] = useState(getCurrentUser());
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    function onStorage() {
      setUser(getCurrentUser());
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  function onLogout() {
    logout();
    setUser(null);
    navigate('/');
  }

  const menuItems = [
    { key: 'profile', label: '资料' },
    { key: 'settings', label: '设置' },
    { type: 'divider' },
    { key: 'logout', label: '退出' },
  ];

  function onMenuClick({ key }) {
    if (key === 'profile') navigate('/me');
    else if (key === 'settings') navigate('/settings');
    else if (key === 'logout') onLogout();
  }

  return (
    <header className="nav">
      <div className="nav-inner">
        <h2 className="brand"><Link to="/">MyBlog</Link></h2>
        <nav className="nav-bar">
          <div className="nav-left">
            <Link to="/">Home</Link>
            <Link to="/archive">归档</Link>
          </div>

          <div className="nav-right">
            {user ? (
              <>
                <Link to="/new">写文章</Link>
                <Link to="/me" className={`nav-my ${location.pathname === '/me' ? 'active' : ''}`}><UserOutlined style={{ marginRight: 6 }} />我的</Link>

                <Dropdown menu={{ items: menuItems, onClick: onMenuClick }} placement="bottomRight" trigger={["click"]}>
                  <span className="user-info">
                    <Avatar src={user.profile?.avatarUrl || '/avatar-placeholder.svg'} size={32} onClick={(e)=>{ e.stopPropagation(); navigate('/me'); }} style={{ cursor: 'pointer' }} />
                    <span className="user-name">{user.profile?.displayName || user.username}</span>
                  </span>
                </Dropdown>

                <button onClick={onLogout} className="del">退出</button>
              </>
            ) : (
              <>
                <Link to="/login">登录</Link>
                <Link to="/register">注册</Link>
              </>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
}
